var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "pix-flag",
    attrs: { src: _vm.flagSrc, alt: "Country Flag" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }